import { render, staticRenderFns } from "./GridTech.vue?vue&type=template&id=6ed71521&"
import script from "./GridTech.vue?vue&type=script&lang=js&"
export * from "./GridTech.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports